import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navigation from "./components/Navigation";
import Slideshow from "./components/Slideshow/Slideshow";
import Services from "./components/Services";
import AboutUs from "./components/AboutUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer/Footer";
import Pricing from "./pages/Pricing";

const slides = [
    { type: 'image', src: '/images/home1.jpg' },
    { type: 'image', src: '/images/home2.jpg' },
    { type: 'image', src: '/images/home3.jpg' },
    { type: 'image', src: '/images/home4.jpg' },
    { type: 'image', src: '/images/home5.jpg' },
    { type: 'image', src: '/images/home6.jpg' },
    { type: 'image', src: '/images/home7.jpg' },
    { type: 'image', src: '/images/home8.jpg' },
    { type: 'image', src: '/images/home9.jpg' },
    { type: 'image', src: '/images/home10.jpg' },
    { type: 'image', src: '/images/home11.jpg' },
    { type: 'image', src: '/images/home12.jpg' },
    { type: 'image', src: '/images/home13.jpg' },
    { type: 'image', src: '/images/home14.jpg' }
  ];

const ScrollToSection = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const id = location.state.scrollTo;
      const timer = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return null
};

const HomePage = () => (
  <div className = "font-sans">
    <ScrollToSection />
    <Navigation />
    <Slideshow slides={slides} />
    <Services />
    <AboutUs />
    <Contact />
    <Footer />
  </div>
);

const PricingPage = () => (
  <div className="font-sans">
    <Navigation />
    <Pricing />
    <Footer />
  </div>
);


const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/pricing" element={<PricingPage />} />
    </Routes>
  </BrowserRouter>
);
export default App;